import { useNavigate } from 'react-router-dom';
import './cart.css';
import { useCart } from './CartContext';

const Cart = () => {
  const { cartItems, incrementQty, decrementQty, removeFromCart } = useCart();
  const navigate = useNavigate();

  const goToProducts = () => {
    navigate('/products');
  };

  return (
    <div className="cart-container">
      <button className="back-btn" onClick={goToProducts}>⟵ Back to Products</button>

      <h1>Your Cart</h1>
      <div className="finalize-btn-top">
        <button className="finalize-btn" onClick={() => navigate('/enquiry')}>
          Finalize & Enquire Now
        </button>
      </div>

      <div className="cart-header">
        <span>PRODUCT</span>
        <span>QTY</span>
      </div>

      {cartItems.length === 0 ? (
        <p className="empty-msg">Your cart is empty</p>
      ) : (
        cartItems.map((item, index) => (
          <div className="cart-item" key={index}>
            <div className="product-info">
              <img src={item.image} alt={item.name} />
              <div>
                <h4>{item.name}</h4>
                <p>{item.qtyCount} × {item.qtyType}</p>
              </div>
            </div>

            <div className="cart-actions">
              <button onClick={() => decrementQty(index)}>-</button>
              <span>{item.qtyCount}</span>
              <button onClick={() => incrementQty(index)}>+</button>
              <button
                className="delete-btn"
                onClick={() => removeFromCart(index)}
              >
                🗑️ Delete
              </button>
            </div>
          </div>
        ))
      )}

      <div className="finalize-btn-wrap">
        <button className="finalize-btn" onClick={() => navigate('/enquiry')}>
          Finalize & Enquire Now
        </button>
      </div>
    </div>
  );
};

export default Cart;
